/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactWeather
 */
export interface ContactWeather {
    /**
     * 
     * @type {number}
     * @memberof ContactWeather
     */
    tempF?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactWeather
     */
    humidity?: number;
}

/**
 * Check if a given object implements the ContactWeather interface.
 */
export function instanceOfContactWeather(value: object): boolean {
    return true;
}

export function ContactWeatherFromJSON(json: any): ContactWeather {
    return ContactWeatherFromJSONTyped(json, false);
}

export function ContactWeatherFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactWeather {
    if (json == null) {
        return json;
    }
    return {
        
        'tempF': json['tempF'] == null ? undefined : json['tempF'],
        'humidity': json['humidity'] == null ? undefined : json['humidity'],
    };
}

export function ContactWeatherToJSON(value?: ContactWeather | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tempF': value['tempF'],
        'humidity': value['humidity'],
    };
}

